export default __webpack_public_path__ + "static/hm-41625c5168645de4d3d8f9040641e0ae.svg";